var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"alert-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"dialog-tips dialog-center",attrs:{"id":"toast"}},[_c('svg',{staticClass:"ico w2x h2x fPrimary mr05x"},[_c('use',{attrs:{"xlink:href":"#status-info"}})]),_vm._v("\n\t\t"+_vm._s(_vm.message)+"\n\t")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4249b30d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/toast/toast.vue
// module id = null
// module chunks = 